import {Assert, AwaitTree, Clone, E, SleepAsync, ToJSON} from "js-vextensions";
import {ConvertDataToValidDBUpdates, GetAsync, GetDoc, GetDocs, observer_mgl, SplitStringBySlash_Cached} from "mobx-graphlink";
import {Button, Column, Row, TextArea} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {ShowMessageBox} from "react-vmessagebox";
import {Observer, PageContainer} from "web-vcore";
import {MeID} from "../../Server/DB/users.js";
import {HasAdminPermissions} from "../../Server/DB/users/$user.js";
import React from "react";

export const AdminUI = observer_mgl(()=>{
	let isAdmin = HasAdminPermissions(MeID());
	if (!isAdmin) return <PageContainer>Please sign in.</PageContainer>;
	
	return (
		<PageContainer scrollable={true}>
			<Row m="-10px 0"><h2>Database</h2></Row>
			<Row><h4>Testing</h4></Row>
			<Row>
				<Button text={"Throw async error"} onClick={async()=>{
					await SleepAsync(1000);
					throw new Error("Oh no!");
				}}/>
			</Row>
			<Row mt={5}>
				<Button text="Show local-storage data" onClick={()=>{
					//let newJSON = ToJSON_WithSpaces(config);
					let newJSON = ToJSON(Clone(localStorage), undefined, 4);
					const boxController = ShowMessageBox({
						title: "Local-storage data", //cancelButton: true,
						message: ()=>{
							return (
								//<Column style={DialogStyle({width: 800})}>
								<Column>
									<Row>Data (as json):</Row>
									<TextArea style={{width: 800..KeepAtMost(window.innerWidth - 100), height: window.innerHeight - 200}} value={newJSON} onChange={val=>{
										newJSON = val;
										boxController.UpdateUI();
									}}/>
								</Column>
							);
						},
						onOK: ()=>{
							// maybe someday, make it possible to edit local-storage from here; for now, just for viewing
						},
					});
				}}/>
			</Row>
		</PageContainer>
	);
});